module.exports = __webpack_public_path__ + "34055724287a32bdc931488db868c540.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/video_placeholder.jpg
// module id = 188
// module chunks = 0